import enFlag from 'flag-icons/flags/4x3/gb.svg';
import frFlag from 'flag-icons/flags/4x3/fr.svg';
import esFlag from 'flag-icons/flags/4x3/es.svg';
import ptFlag from 'flag-icons/flags/4x3/pt.svg';

export enum Locale {
  Spanish = 'es',
  English = 'en',
  French = 'fr',
  Portuguese = 'pt'
}

export const LOCALES = [
  {
    id: Locale.Spanish,
    name: 'Español',
    flag: esFlag
  },
  {
    id: Locale.English,
    name: 'English',
    flag: enFlag
  },
  {
    id: Locale.French,
    name: 'French',
    flag: frFlag
  },
  {
    id: Locale.Portuguese,
    name: 'Português',
    flag: ptFlag
  }
];

export const ENABLED_LOCALES = [Locale.Spanish, Locale.English, Locale.French, Locale.Portuguese];
